import countries from './countries';
import { ROUTES, Routes_DE, Routes_EN } from './routes';

export { ROUTES, Routes_DE, Routes_EN };

export enum SupportedLocales {
  DE = 'de',
  EN = 'en',
  DEFAULT = DE,
}

export enum SupportedCurrencies {
  EURO = 'EUR',
  DEFAULT = EURO,
}

export enum ViewModes {
  LIST = 'LIST',
  GRID = 'GRID',
  DEFAULT = GRID,
}

export enum ConsumptionType {
  KWH = 'kWh',
  LITERS_PER_KM = 'l/100km',
}

export enum DropdownOpenHeight {
  MAX = 'max',
  MEDIUM = 'medium',
  DEFAULT = MAX,
  MIN = 'min',
}

export enum TradeInFlowType {
  PDP = 'pdpFlow',
  GARAGE = 'garageFlow',
  SHOPPING_CART = 'scartFlow',
  SHOPPING_CART_STANDALONE = 'scartSecFlow',
  STANDALONE = 'standFlow',
  OTHER = 'otherFlow',
}

export enum NewsletterSource {
  SubscribeForm = 'MA00000001',
  SubscribeAccountPage = 'MA00000002',
  SubscribeAccountCreation = 'MA00000007',
  SubscribeContactDealerCommon = 'MA00000022',
  SubscribeContactDealerVideo = 'MA00000049',
  SubscribeServiceBooking = 'MA00000048',
  SubscribeTestDrive = 'MA00000036',
  SubscribeTradeIn = 'MA00000037',
  UnsubscribeAccount = 'MA00000003',
}

export const OVERLAY_ADD_PADDING_CLASSNAME =
  'alles-auto-overlay-add-padding add-border-class';

export const ASPECT_RATIO_16_x_9 = {
  WIDTH: 16,
  HEIGHT: 9,
};

export const ASPECT_RATIO_16_x_10 = {
  WIDTH: 16,
  HEIGHT: 10,
};

export const VEHICLE_TEASER_CUSTOM_RATIO = {
  WIDTH: 440,
  HEIGHT: 456,
};

export interface StepperStep {
  key: number;
  label: string;
  wl_label?: string;
  links: string[];
  headline: string;
  wl_headline?: string;
  description: string;
  wl_description?: string;
  btnText?: string;
}

export const consts = {
  INVALID_TOKEN_ERROR_MESSAGE: 'Invalid access token.',
  COOKIES: {
    USER_TOKEN: 'user_session',
    SHOPPING_CART_UUID: 'shopping-cart-uuid',
  },
  CURRENCIES: {
    EUR: {
      SHORT: '€',
      LONG: ' Euro',
    },
  },
  UNITS: {
    CUBIC_CAPACITY: 'ccm',
    KILOMETER: 'km',
  },
  API_URLS: {
    EXTERNAL: {
      GOOGLE_MAPS: {
        PLACES_AUTOCOMPLETE_API:
          'https://maps.googleapis.com/maps/api/place/autocomplete/json',
        GEOCODING_API:
          'https://maps.googleapis.com/maps/api/geocode/json?language=de',
      },
      GOOGLE_RECAPTCHA: {
        VERIFY_API: 'https://www.google.com/recaptcha/api/siteverify',
      },
      CONFIGURATOR: {
        SCRIPT_URL: 'https://allesauto-staging.cd-systeme.rocks/js/app.js',
        STYLES_URL: 'https://allesauto-staging.cd-systeme.rocks/css/app.css',
      },
      NEWSLETTER: {
        TOKEN:
          'https://mc0bmzwqk1238gd2xpbvbcx6t5gy.auth.marketingcloudapis.com/v2/token',
      },
      ACCESSORIES: {
        CATEGORIES: '/navigation/categories',
        PRODUCTS_IN_CATEGORY: '/products/forCategory',
        PRODUCTS_TOP_RATED: '/products/topRated',
        PRODUCTS_SEARCH: '/products/search',
        PRODUCT_DETAILS: '/product/detail',
      },
      ACCESSORIES_WIDGET: {
        STYLES: '/static/css/main.css',
        RUNTIME_MAIN: '/static/js/runtime-main.js',
        MAIN: '/static/js/main.js',
      },
    },
    INTERNAL: {
      GOOGLE_MAPS: {
        PLACES_AUTOCOMPLETE_API: '/api/googlemaps/places/autocomplete',
        GEOCODING_API: '/api/googlemaps/geocoding',
        GEOCODING_ZIPSEARCH_API: '/api/googlemaps/geocoding/zipsearch',
      },
      NEWSLETTER: {
        SUBSCRIBE: '/api/newsletter/subscribe/',
        UNSUBSCRIBE: '/api/newsletter/unsubscribe/',
      },
      ACCESSORIES: {
        CATEGORIES: '/api/accessories/categories/',
        PRODUCTS_IN_CATEGORY: '/api/accessories/products/inCategory/',
        PRODUCTS_TOP_RATED: '/api/accessories/products/topRated/',
        PRODUCTS_SEARCH: '/api/accessories/products/search/',
        PRODUCT_DETAILS: '/api/accessories/product/',
      },
    },
  },
  MERCHANT_PORTAL_URL: 'https://haendlerportal.alles.auto',
  GEOCODING: {
    COUNTRY: 'DE',
  },
  FALLBACK_IMAGES: {
    GARAGE_VEHICLE: 'assets/images/fallback.webp',
    PCP_PDP: 'assets/images/fallback_pcp_pdp.webp',
    TRADE_IN_WIDGET: 'assets/images/fallback_trade_in_widget.webp',
  },
  PCP: {
    HORIZONTAL_TOOLBAR: {
      RESULTS_PER_PAGE: [24, 36, 48, 60],
      RESULTS_PER_PAGE_DEFAULT: 24,
      VIEWMODES: [ViewModes.LIST, ViewModes.GRID],
      SORTING_DEFAULT: {
        SUBJECT: 'ADDED',
        DIRECTION: 'DESC',
      },
    },
    FILTERS: {
      MAKE_MODEL_LEVEL_MAX_ITEMS: 3,
      BODY_COLOR_MAX_INITIAL_VISIBLE_ITEMS: 6,
      VEHICLE_CONDITION: {
        NR_OF_CHECKBOXES_SHOWN: 5,
        MILEAGE_DROP_DOWN_ITEMS: [
          {
            label: '10.000',
            value: 10000,
          },
          {
            label: '20.000',
            value: 20000,
          },
          {
            label: '30.000',
            value: 30000,
          },
          {
            label: '40.000',
            value: 40000,
          },
          {
            label: '50.000',
            value: 50000,
          },
          {
            label: '60.000',
            value: 60000,
          },
          {
            label: '70.000',
            value: 70000,
          },
          {
            label: '80.000',
            value: 80000,
          },
          {
            label: '90.000',
            value: 90000,
          },
          {
            label: '100.000',
            value: 100000,
          },
          {
            label: '125.000',
            value: 125000,
          },
          {
            label: '150.000',
            value: 150000,
          },
          {
            label: '175.000',
            value: 175000,
          },
          {
            label: '200.000+',
            value: 200000,
          },
        ],
        PREVIOUS_OWNERS_SLIDER_VALUES: {
          min: 0,
          max: 4,
          step: 1,
        },
      },
      INTERIOR_COLOR_MAX_INITIAL_VISIBLE_ITEMS: 6,
      LOCATION_RADIUS_OPTIONS: [20, 50, 100, 200, 300, 400, 500, 900],
      LOCATION_RADIUS_DEFAULT: 200,
    },
  },
  PDP: {
    CONTACT_DEALER_FORM: {
      TEXTAREA_CHARACTER_LIMIT: 500,
    },
    DEALER_INFO: {
      GOOGLE_MAPS_PLACE: 'https://www.google.com/maps/place/',
    },
    CONFIGURABLE_CAR_CONDITION: 'konfigurierbar',
    CONFIGURABLE_NEW_CAR: 'Neuwagen (konfigurierbar)',
  },
  FORMS: {
    PRIVACY_AA_EMAIL: 'privacy@alles.auto',
  },
  DEALER_FINDER: {
    SEARCH_DISTANCE: 100, // in km
    MAX_LIMIT_DEALERS_VISIBLE: 12,
  },
  NAVIGATION_DUMMY_NOTIFICATIONS_NUMBER: 3,
  SERVICE_BOOKING: {
    SERVICE_DESCRIPTION: {
      MAX_NUMBER_OF_CHARACTERS: 170,
    },
  },
  COLOR_OPTIONS_INDICATA: [
    'BEIGE',
    'BLACK',
    'BLUE',
    'BROWN',
    'GOLD',
    'GREEN',
    'GREY',
    'ORANGE',
    'PINK',
    'PURPLE',
    'RED',
    'SILVER',
    'WHITE',
    'YELLOW',
  ],
  PREFERRED_MAKES_INDICATA: [
    'Audi',
    'BMW',
    'Ford',
    'Mercedes-Benz',
    'Opel',
    'Škoda',
    'VW',
  ],
  PREFERRED_MAKES: [
    {
      name: 'AUDI',
      displayName: 'AUDI',
    },
    {
      name: 'BMW',
      displayName: 'BMW',
    },
    {
      name: 'FORD',
      displayName: 'FORD',
    },
    {
      name: 'MERCEDES-BENZ',
      displayName: 'MERCEDES-BENZ',
    },
    {
      name: 'OPEL',
      displayName: 'OPEL',
    },
    {
      name: 'SKODA',
      displayName: 'SKODA',
    },
    {
      name: 'VW',
      displayName: 'VW',
    },
  ],
  GTM_PAGE_TYPES: {
    HOME: 'home',
    ACCOUNT: 'account',
    BUY_CAR_ONLINE: 'buy-car-online',
    CAR_ACCESSORIES: 'car-accessories',
    CAR_SELL: 'car-sell',
    CAREER: 'career',
    CARS: 'cars',
    CHECKOUT: 'checkout',
    CONSULTING_INFORMATION: 'consulting-information',
    CONTACT_SUPPORT: 'contact-support',
    DEALER_OVERVIEW: 'dealer-overview',
    GARAGE: 'garage',
    HELP_FAQS: 'help-faqs',
    INFO_FOR_DEALERS: 'info-for-dealers',
    NEWSLETTER: 'newsletter',
    OFFER_OVERVIEW: 'offer-overview',
    PAYMENT_METHODS: 'payment-methods',
    PRICE_CHECK: 'price-check',
    PRIVATE_SALE: 'private-sale',
    SERVICE_BOOKING: 'service-booking',
    CART: 'cart',
    TRADE_IN: 'tradein',
    WHITE_LABEL: 'whitelabel',
    WORKSHOP_SERVICES: 'workshop-services',
  },
  FILE_UPLOAD: {
    FILE_KEY_PREFIX: 'aa-upload-',
    CONFIG_DATE_FORMAT: `yyyyMMdd'T'HHmmssX`,
    CONFIG_EXPIRATION: 20, // minutes
    CONFIG_EXPIRATION_BUFFER: 2, // minutes
  },
  INTERSECTION_OBSERVER: {
    THRESHOLD: 0.5,
  },
  FAVORITES: {
    MAX_NUMBER_OF_COMPARED_VEHICLES: 3,
  },
  IMACA_IMAGE: 'imaca_img',
};

export enum ToastifyPosition {
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  TOP_CENTER = 'top-center',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_CENTER = 'bottom-center',
}

export enum ToastifyType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default',
}

export enum ToastifyTheme {
  DARK = 'dark',
  LIGHT = 'light',
  COLORED = 'colored',
}

export const toasterDefaultOptions = {
  theme: ToastifyTheme.LIGHT,
  position: ToastifyPosition.TOP_RIGHT,
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
};

export enum HeadlineVariation {
  H1 = 1,
  H2,
  H3,
  H4,
  H5,
}

export enum NavigationIconLinkType {
  CONTACT = 'contact',
  HELP_FAQ = 'helpFaq',
  USER = 'user',
  USER_REGISTER = 'userRegister',
  GARAGE = 'stayInside',
  ORDER = 'task',
  USER_DATA = 'userProfile',
  ADDRESS_BOOK = 'catalog',
  FAVORITE = 'favorite',
  LOGOUT = 'logout',
}

export type DynamicIconType =
  | 'application'
  | 'batteryCharging'
  | 'calendar'
  | 'car'
  | 'carFront'
  | 'certificate'
  | 'certificateCheck'
  | 'chart'
  | 'chat'
  | 'checkmark'
  | 'circle'
  | 'colorPalette'
  | 'compass'
  | 'concept'
  | 'connect'
  | 'currencyEuro'
  | 'dataCheck'
  | 'decisionTree'
  | 'delivery'
  | 'development'
  | 'document'
  | 'faceSatisfied'
  | 'faceWink'
  | 'favorite'
  | 'grid'
  | 'helpDesk'
  | 'home'
  | 'idea'
  | 'location'
  | 'locationHeart'
  | 'logoFacebook'
  | 'magicWand'
  | 'money'
  | 'mountain'
  | 'nextArrow'
  | 'notificationNew'
  | 'partnership'
  | 'personFavorite'
  | 'phoneFilled'
  | 'record'
  | 'rocket'
  | 'rotate180'
  | 'scan'
  | 'search'
  | 'securityServiceDesk'
  | 'serviceDesk'
  | 'shuffle'
  | 'snowFlake'
  | 'star'
  | 'store'
  | 'switcher'
  | 'template'
  | 'time'
  | 'timer'
  | 'unlocked'
  | 'user'
  | 'userCertification'
  | 'userFavorite'
  | 'userServiceDesk'
  | 'vehicleServices'
  | 'warning'
  | 'watsonHealth'
  | 'wiki'
  | 'workspace'
  | 'linkedin'
  | 'xing'
  | 'kununu'
  | 'zoomReset';

export enum ImagePosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum Background {
  WHITE = 'WHITE',
  PURPLE = 'PURPLE',
  GREY = 'GREY',
}

export enum BenefitBackground {
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
  WHITE = 'WHITE',
  GREY = 'GREY',
  DEFAULT = 'DEFAULT',
}

export enum ContentStepBackground {
  GREEN = 'GREEN',
  GREY = 'GREY',
  WHITE = 'WHITE',
}

export enum TextComponentBackground {
  GREY = 'GREY',
  DEFAULT = 'DEFAULT',
}

export enum AccountActionType {
  EDIT = 'edit',
  DELETE = 'delete',
  ADD = 'add',
}

export const CheckoutSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.LABEL',
    wl_label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.LABEL_WL',
    links: [Routes_DE.CHECKOUT],
    headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.HEADLINE',
    wl_headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.HEADLINE_WL',
    description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.DESCRIPTION',
    wl_description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.0.DESCRIPTION_WL',
  },
  {
    key: 1,
    label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.LABEL',
    wl_label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.LABEL_WL',
    links: [Routes_DE.CHECKOUT_STEPS.BILLING, Routes_EN.CHECKOUT_STEPS.BILLING],
    headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.HEADLINE',
    wl_headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.HEADLINE_WL',
    description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.DESCRIPTION',
    wl_description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.1.DESCRIPTION_WL',
  },
  {
    key: 2,
    label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.LABEL',
    wl_label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.LABEL_WL',
    links: [
      Routes_DE.CHECKOUT_STEPS.DELIVERY,
      Routes_EN.CHECKOUT_STEPS.DELIVERY,
    ],
    headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.HEADLINE',
    wl_headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.HEADLINE_WL',
    description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.DESCRIPTION',
    wl_description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.2.DESCRIPTION_WL',
  },
  {
    key: 3,
    label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.LABEL',
    wl_label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.LABEL_WL',
    links: [Routes_DE.CHECKOUT_STEPS.PAYMENT, Routes_EN.CHECKOUT_STEPS.PAYMENT],
    headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.HEADLINE',
    wl_headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.HEADLINE_WL',
    description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.DESCRIPTION',
    wl_description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.3.DESCRIPTION_WL',
  },
  {
    key: 4,
    label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.LABEL',
    wl_label: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.LABEL_WL',
    links: [
      Routes_DE.CHECKOUT_STEPS.CONFIRMATION,
      Routes_EN.CHECKOUT_STEPS.CONFIRMATION,
    ],
    headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.HEADLINE',
    wl_headline: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.HEADLINE_WL',
    description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.DESCRIPTION',
    wl_description: 'ui.CHECKOUT.STEP_INDICATOR_STEPS.4.DESCRIPTION_WL',
  },
];

export const BookingSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.0.LABEL',
    links: [Routes_DE.SERVICE_BOOKING],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.0.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.0.DESCRIPTION',
  },
  {
    key: 1,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.1.LABEL',
    links: [
      Routes_DE.SERVICE_BOOKING_STEPS.WORKSHOP,
      Routes_EN.SERVICE_BOOKING_STEPS.WORKSHOP,
    ],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.1.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.1.DESCRIPTION',
  },
  {
    key: 2,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.2.LABEL',
    links: [
      Routes_DE.SERVICE_BOOKING_STEPS.APPOINTMENT,
      Routes_EN.SERVICE_BOOKING_STEPS.APPOINTMENT,
    ],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.2.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.2.DESCRIPTION',
  },
  {
    key: 3,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.3.LABEL',
    links: [
      Routes_DE.SERVICE_BOOKING_STEPS.CONTACT,
      Routes_EN.SERVICE_BOOKING_STEPS.CONTACT,
    ],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.3.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.3.DESCRIPTION',
  },
  {
    key: 4,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.4.LABEL',
    links: [
      Routes_DE.SERVICE_BOOKING_STEPS.SUMMARY,
      Routes_EN.SERVICE_BOOKING_STEPS.SUMMARY,
    ],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.4.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.4.DESCRIPTION',
  },
  {
    key: 5,
    label: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.5.LABEL',
    links: [
      Routes_DE.SERVICE_BOOKING_STEPS.CONFIRMATION,
      Routes_EN.SERVICE_BOOKING_STEPS.CONFIRMATION,
    ],
    headline: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.5.HEADLINE',
    description: 'ui.SERVICE_BOOKING.STEP_INDICATOR_STEPS.5.DESCRIPTION',
  },
];
export const TradeInSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.LABEL',
    links: [Routes_DE.TRADE_IN],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.DESCRIPTION_WL',
  },
  {
    key: 1,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.LABEL',
    links: [
      Routes_DE.TRADE_IN_STEPS.EQUIP_COND,
      Routes_EN.TRADE_IN_STEPS.EQUIP_COND,
    ],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.DESCRIPTION_WL',
  },
  {
    key: 2,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.LABEL',
    links: [Routes_DE.TRADE_IN_STEPS.DEALER, Routes_EN.TRADE_IN_STEPS.DEALER],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.DESCRIPTION_WL',
  },
  {
    key: 3,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.LABEL',
    links: [Routes_DE.TRADE_IN_STEPS.OFFER, Routes_EN.TRADE_IN_STEPS.OFFER],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.DESCRIPTION_WL',
  },
];

export const TradeInWidgetSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.LABEL_TRADE_IN_WIDGET',
    links: [Routes_DE.TRADE_IN],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.DESCRIPTION_WL',
    btnText: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.0.BUTTON_TEXT',
  },
  {
    key: 1,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.LABEL_TRADE_IN_WIDGET',
    links: [
      Routes_DE.TRADE_IN_STEPS.EQUIP_COND,
      Routes_EN.TRADE_IN_STEPS.EQUIP_COND,
    ],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.DESCRIPTION_WL',
    btnText: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.1.BUTTON_TEXT',
  },
  {
    key: 2,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.LABEL_TRADE_IN_WIDGET',
    links: [Routes_DE.TRADE_IN_STEPS.DEALER, Routes_EN.TRADE_IN_STEPS.DEALER],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.DESCRIPTION_WL',
    btnText: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.2.BUTTON_TEXT',
  },
  {
    key: 3,
    label: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.LABEL_TRADE_IN_WIDGET',
    links: [Routes_DE.TRADE_IN_STEPS.OFFER, Routes_EN.TRADE_IN_STEPS.OFFER],
    headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.HEADLINE',
    wl_headline: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.HEADLINE_WL',
    description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.DESCRIPTION',
    wl_description: 'ui.TRADE_IN.STEP_INDICATOR_STEPS.3.DESCRIPTION_WL',
  },
];

export const C2CSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.C2C.STEP_INDICATOR_STEPS.0.LABEL',
    links: [Routes_DE.C2C],
    headline: 'ui.C2C.STEP_INDICATOR_STEPS.0.HEADLINE',
    description: 'ui.C2C.STEP_INDICATOR_STEPS.0.DESCRIPTION',
  },
  {
    key: 1,
    label: 'ui.C2C.STEP_INDICATOR_STEPS.1.LABEL',
    links: [Routes_DE.C2C_STEPS.IMAGES, Routes_EN.C2C_STEPS.IMAGES],
    headline: 'ui.C2C.STEP_INDICATOR_STEPS.1.HEADLINE',
    description: 'ui.C2C.STEP_INDICATOR_STEPS.1.DESCRIPTION',
  },
  {
    key: 2,
    label: 'ui.C2C.STEP_INDICATOR_STEPS.2.LABEL',
    links: [Routes_DE.C2C_STEPS.CONFIRMATION, Routes_EN.C2C_STEPS.CONFIRMATION],
    headline: 'ui.C2C.STEP_INDICATOR_STEPS.2.HEADLINE',
    description: 'ui.C2C.STEP_INDICATOR_STEPS.2.DESCRIPTION',
  },
];

export const BankingRequestSteps: StepperStep[] = [
  {
    key: 0,
    label: 'ui.BANKING_REQUEST.STEP_INDICATOR_STEPS.0.LABEL',
    headline: '',
    description: '',
    links: [Routes_DE.BANKING_REQUEST],
  },
  {
    key: 1,
    label: 'ui.BANKING_REQUEST.STEP_INDICATOR_STEPS.1.LABEL',
    headline: '',
    description: '',
    links: [
      Routes_DE.BANKING_REQUEST_STEPS.HOUSEHOLD_WORK,
      Routes_EN.BANKING_REQUEST_STEPS.HOUSEHOLD_WORK,
    ],
  },
  {
    key: 2,
    label: 'ui.BANKING_REQUEST.STEP_INDICATOR_STEPS.2.LABEL',
    headline: '',
    description: '',
    links: [
      Routes_DE.BANKING_REQUEST_STEPS.INCOME_EXPENSES,
      Routes_EN.BANKING_REQUEST_STEPS.INCOME_EXPENSES,
    ],
  },
  {
    key: 3,
    label: 'ui.BANKING_REQUEST.STEP_INDICATOR_STEPS.3.LABEL',
    headline: '',
    description: '',
    links: [
      Routes_DE.BANKING_REQUEST_STEPS.INCOME_DETAILS,
      Routes_EN.BANKING_REQUEST_STEPS.INCOME_DETAILS,
    ],
  },
  {
    key: 4,
    label: 'ui.BANKING_REQUEST.STEP_INDICATOR_STEPS.4.LABEL',
    headline: '',
    description: '',
    links: [
      Routes_DE.BANKING_REQUEST_STEPS.CONFIRMATION,
      Routes_EN.BANKING_REQUEST_STEPS.CONFIRMATION,
    ],
  },
];

export enum UserSalutationTypes {
  HERR = 'Herr',
  FRAU = 'Frau',
  DIVERS = 'Divers',
}

export enum ListMarkerColor {
  GREEN = 'GREEN',
  PURPLE = 'PURPLE',
  DEFAULT = GREEN,
}

export enum ListMarkerType {
  BULLET = 'BULLET',
  CHECKMARK = 'CHECKMARK',
  RECTANGLE = 'RECTANGLE',
  DEFAULT = BULLET,
}

export enum TileBackground {
  PURPLE = 'PURPLE',
  GREEN = 'GREEN',
  WHITE = 'WHITE',
  GREY = 'GREY',
  DEFAULT = PURPLE,
}

export enum PickupType {
  SEALING_DEALER = 'SEALING_DEALER',
  OTHER_DEALER = 'OTHER_DEALER',
  DELIVERY = 'DELIVERY',
}

export enum PaymentOptionExtrasType {
  PAYMENT_AT_DEALER = 'PAYMENT_AT_DEALER',
  PAYMENT_CARD = 'PAYMENT_CARD',
  PAYMENT_BANK_TRANSFER = 'PAYMENT_BANK_TRANSFER',
}

export const OBJECT_CONTAIN = 'object-contain';
export const OBJECT_COVER = 'object-cover';

export enum VehicleCardBackground {
  WHITE = 'WHITE',
  GREEN = 'GREEN',
  BLACK = 'BLACK',
  PURPLE = 'PURPLE',
  DEFAULT = WHITE,
}

export enum VehicleCondition {
  USED = 'Gebrauchtwagen',
}

export const ANIMATION_DURATION = 400;

export const MAX_NUMBER_OF_TILES = 6;

export enum CtaTeaserTypes {
  IMAGE = 'image',
  FRAME = 'frame',
  ICON = 'icon',
}

export enum BrandTypes {
  mediumImage = 'mediumImage',
  largeImage = 'largeImage',
}

export { countries };

export enum TextComponentTypesLeft {
  PICTURE = 'Picture',
  TITLE = 'Title',
  TESTIMONIAL = 'Testimonial',
  NONE = 'None',
}

export enum TextComponentTypes {
  ACCORDION = 'Accordion',
}

export enum TextComponentPostion {
  LEFT = 'Left',
  RIGHT = 'Right',
}

export enum AnimationType {
  WARNING = 'warning',
  SUCCESS = 'success',
}

export enum GTMFilterCategory {
  LOCATION = 'LOCATION',
  MERCHANT_LOCATION = 'MERCHANT_LOCATION',
  VEHICLE_TYPE = 'VEHICLE_TYPE',
  MAKE_MODEL = 'MAKE_MODEL',
  PRICE = 'PRICE',
  VEHICLE_CONDITION = 'VEHICLE_CONDITION',
  FUEL = 'FUEL',
  DRIVE = 'DRIVE',
  BODY_COLORS = 'BODY_COLORS',
  EQUIPMENT = 'EQUIPMENT',
  INTERIOR = 'INTERIOR',
  EMISSION = 'EMISSION',
}

export const SUPPORT_EMAIL_ADDRESS = 'kundenservice@alles.auto';

export const INFO_DEALERS_EMAIL_ADDRESS = 'mitmachen@alles.auto';

export const INFO_EMAIL_ADDRESS = 'info@alles.auto';

export const PRESS_EMAIL_ADDRESS = 'presse@alles.auto';

export const PRESS_ITEMS_PER_PAGE = 5;

export const ACCESSORY_ITEMS_PER_PAGE = 24;

export const ACCESSORY_PAGINATION_VISIBLE_PAGES_COUNT = 8;

export const ACCESSORY_CART_SKU = 'AC_1000000001-1';

export const ACCESSORY_STANDALONE_CART_SKU = 'AC_1000000002-1';

export const ACCESSORY_STANDALONE_SHIPMENT_SKU = 'itt_pickup_at_dealer-1';

export const TRADE_IN_CART_SKU = 'TI1000000001-1';

export const TRADE_IN_SHIPMENT_SKU = 'avag_pickup_at_dealer-1';

export const ACCESSORY_STANDALONE_SHIPMENT_DELIVERY_SKU = 'itt_door_to_door-1';

export const InitialPriceFilterState = {
  key: '',
  max: 0,
  min: 0,
} as const;

export enum BackgroundImages {
  LOGIN_SCREEN = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/alles-auto-login.webp',
  NEWSLETTER_SCREEN = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/alles-auto-newsletter.webp',
  C2C_IMAGE_HINT_OK_1 = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/c2c_garage_do_01.webp',
  C2C_IMAGE_HINT_WRONG_1 = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/c2c_garage_dont_01.webp',
  C2C_IMAGE_HINT_OK_2 = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/c2c_garage_do_02.webp',
  C2C_IMAGE_HINT_WRONG_2 = 'https://d1r1ppqc6t030u.cloudfront.net/assets/images/c2c_garage_dont_02.webp',
}

export const VIN_IMAGE =
  'https://d1r1ppqc6t030u.cloudfront.net/assets/cdn/vin.jpg';
export const VIN_IMAGE_AT =
  'https://d1r1ppqc6t030u.cloudfront.net/assets/cdn/vin_at.jpg';
export const FIRST_REGISTRATION_IMAGE =
  'https://d1r1ppqc6t030u.cloudfront.net/assets/cdn/erstzulassung.jpg';
export const FIRST_REGISTRATION_IMAGE_AT =
  'https://d1r1ppqc6t030u.cloudfront.net/assets/cdn/erstzulassung_at.png';

export enum FinanceType {
  FINANCING = 'Finanzierungs',
  LEASING = 'Leasing',
  CASH = 'Barkauf',
}

export enum FinanceTypeEn {
  FINANCING = 'Finance',
  LEASING = 'Leasing',
  CASH = 'Cash',
  EMPTY = '',
}

export interface PdpParams {
  markName?: string | null;
  modelName?: string | null;
  accessoryParam?: string | null;
  variantName?: string | null;
  id: string;
  dealerId?: string | null;
  categoryId?: string | null;
}

export interface PdpAccessoriesParams {
  model?: string;
  variant?: string;
  categoryId?: string;
  dealerId?: string;
}

export enum FuelType {
  GAS = 'Autogas',
  NATURAL_GAS = 'Erdgas',
  HYDROGEN = 'Wasserstoff',
  ELECTRIC = 'Elektro',
  HYBRID = 'Hybrid',
}

export enum NumberOfBlockedDays {
  EXCLUDING_SUNDAY_WORKING_DAYS = 8,
  EXCLUDING_SUNDAY = 9,
  EXCLUDING_FULL_WEEKEND_WORKING_DAYS = 9,
  EXCLUDING_FULL_WEEKEND = 11,
  NOWAG_EXCLUDING_SUNDAY_WORKING_DAYS = 14,
  NOWAG_INCLUDING_SUNDAY_WORKING_DAYS = 15,
  NOWAG_EXCLUDING_FULL_WEEKEND_WORKING_DAYS = 15,
  NOWAG_INCLUDING_FULL_WEEKEND = 17,
}

export enum DeviceType {
  DESKTOP = 'desktop',
  MOBILE = 'mobile',
  DESKTOP_LARGE = 'desktopLarge',
  TABLET = 'tablet',
}

export const DEFAULT_MERCHANT_NAME = 'Alles.Auto';

export const VEHICLE_BY_ID = `
query vehicleById($vehicleId: String!) {
  vehicleById(vehicleId: $vehicleId) {
  id
  financingDetails {
    monthlyRate
    type
    prepayment
    finalPayment
    duration
    mileage
    summary
  }
  financeCalculatorOptions {
    leasing {
      downPayment {
        min
        max
        default
        step
        isActive
      }
      duration {
        min
        max
        default
        step
        isActive
      }
      mileage {
        min
        max
        default
        step
        isActive
      }
        legalText
    }
    loan {
      downPayment {
        min
        max
        default
        step
        isActive
      } 
      duration {
        min
        max
        default
        step
        isActive
      }
      mileage {
        min
        max
        default
        step
        isActive
      }
      finalInstallmentToggle {
        default
        isActive
      }
      finalInstallment {
        min
        max
        default
        step
        isActive
      }
        insuranceOptions
        legalText
      }
    }
  }
}`;
export const CALCULATE_LOAN_PCP = `
mutation CalculateLoan(
  $vehicleId: String
  $input: LoanCalculationInput
  $configuratorId: String
  $dealerId: String
) {
calculateLoan(
  vehicleId: $vehicleId
  input: $input
  configuratorId: $configuratorId
  dealerId: $dealerId
) {
    monthlyInstallment
    summary
    vehiclePrice
    downPayment
    duration
    netLoanAmount
    effectiveInterestRate
    nominalInterestRate
    totalInterestAmount
    totalRepaymentAmount
    hasFinalInstallment
    finalInstallment
    mileage
  }
}`;
export const CALCULATE_LEASING_PCP = `
mutation CalculateLeasing($vehicleId: String, $input: LeasingCalculationInput) {
  calculateLeasing(vehicleId: $vehicleId, input: $input) {
    monthlyInstallment
    summary
    vehiclePrice
    downPayment
    duration
    netLoanAmount
    effectiveInterestRate
    nominalInterestRate
    totalInterestAmount
    totalRepaymentAmount
    finalInstallment
    hasFinalInstallment
    mileage
  }
}`;

export enum Colors {
  BLACK = 'BLACK',
  GREY = 'GREY',
  DARK_GREY = 'DARK_GREY',
  PURPLE = 'PURPLE',
  WHITE = 'WHITE',
  GREEN = 'GREEN',
  RED = 'RED',
}

export const theme = {
  [Colors.BLACK]: {
    background: 'bg-black monochrome:bg-black',
    text: 'text-black monochrome:text-black',
    fill: 'fill-black monochrome:fill-black',
  },
  [Colors.PURPLE]: {
    background: 'bg-purple80 monochrome:bg-purple80',
    text: 'text-purple80 monochrome:text-purple80',
    fill: 'fill-purple80 monochrome:fill-purple80',
  },
  [Colors.DARK_GREY]: {
    background: 'bg-grey80 monochrome:bg-grey80',
    text: 'text-grey60 monochrome:text-grey60',
    fill: 'fill-grey60 monochrome:fill-grey60',
  },
  [Colors.WHITE]: {
    background: 'bg-white monochrome:bg-white',
    text: 'text-white monochrome:text-white',
    fill: 'fill-white monochrome:fill-white',
  },
  [Colors.GREEN]: {
    background: 'bg-green60 monochrome:bg-green60',
    text: 'text-green60 monochrome:text-green60',
    fill: 'fill-green60 monochrome:fill-green60',
  },
  [Colors.GREY]: {
    background: 'bg-grey10 monochrome:bg-grey10',
    text: 'text-grey20 monochrome:text-grey20',
    fill: 'fill-grey20 monochrome:fill-grey20',
  },
  [Colors.RED]: {
    background: 'bg-red60 monochrome:bg-red60',
    text: 'text-red60 monochrome:text-red60',
    fill: 'fill-red60 monochrome:fill-red60',
  },
};

export const redirectPaths: { [key: string]: string } = {
  [Routes_DE.SHOPPING_CART]: `${
    Routes_DE.ACCOUNT.LOGIN
  }?redirectTo=${encodeURIComponent(Routes_DE.SHOPPING_CART)}`,
  [Routes_DE.TRADE_IN_STEPS.DEALER]: `${
    Routes_DE.ACCOUNT.LOGIN
  }?redirectTo=${encodeURIComponent(Routes_DE.TRADE_IN_STEPS.DEALER)}`,
};
